
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <div className="privacypolicy">
      <h1>London Mapped</h1>
      <h2>Privacy Policy</h2>
      <p>Last updated: 01 September 2026<br></br>

        London Mapped is a restaurant and pub discovery application developed and operated by an independent developer based in the United Kingdom.<br></br><br></br>
        This Privacy Policy explains what personal information London Mapped collects, how it is used, where it is stored, and what choices and rights you have in relation to your information.<br></br><br></br>
        By using London Mapped, you acknowledge the practices described in this Privacy Policy.</p>

      <h3>1. Who is responsible for your information?</h3>

      <p>For the purposes of applicable UK data protection law, The London Mapped team is responsible for the personal information processed through London Mapped. If you have any questions about this Privacy Policy or how your information is handled, you can contact:<br></br><br></br>

      London Mapped Team<br></br>
      Email: hadley.long.dev@gmail.com<br></br>
      United Kingdom</p>

      <h3>2. Information we collect</h3>
      <p><b>Account information</b><br></br><br></br>

      London Mapped allows users to create an account so that they can save restaurants and pubs to their favourites and wishlist.<br></br><br></br>

      Account authentication is provided by Supabase.<br></br><br></br>

      Depending on how you create your account and the authentication method used, Supabase may process information such as your email address, authentication credentials, account identifiers, and information necessary to authenticate your account.<br></br><br></br>

      London Mapped does not maintain a separate user profile containing information such as your name, address, telephone number, or date of birth.<br></br><br></br>

      <b>Favourites and wishlist</b><br></br><br></br>

      When you save a restaurant or pub as a favourite or add it to your wishlist, London Mapped stores:<br></br><br></br>

      Your user account identifier; and The identifier of the restaurant or pub you saved.<br></br><br></br>

      This information allows London Mapped to associate your saved places with your account and display them when you use the app. We do not use your favourites or wishlist to create advertising profiles.<br></br><br></br>

      <b>Information we do not currently collect</b><br></br><br></br>

      At the time this Privacy Policy was last updated, London Mapped does not currently collect:<br></br><br></br>

      Precise device location<br></br>
      Photos uploaded by users<br></br>
      User-to-user messages<br></br>
      Payment or financial information<br></br>
      Advertising identifiers for advertising purposes<br></br>
      Biometric information<br></br>
      Health information<br></br>
      Contacts from your device<br></br><br></br>

      If we introduce features that require additional types of personal information, we will update this Privacy Policy before or when those features are introduced, as appropriate.</p>

      <h3>3. How we use your information</h3>

      <p>We use information associated with your account to:<br></br><br></br>

      Create and authenticate your London Mapped account;<br></br>
      Allow you to save restaurants and pubs as favourites;<br></br>
      Allow you to maintain a wishlist of restaurants and pubs;<br></br>
      Provide the features and functionality of London Mapped;<br></br>
      Maintain and secure the application;<br></br>
      Respond to privacy requests or support enquiries; and<br></br>
      Comply with applicable legal obligations.<br></br><br></br>

      We do not sell your personal information.<br></br><br></br>

      We do not use your information for targeted advertising.</p>

    <h3>4. Our legal basis for processing</h3>

<p>Where UK data protection law applies, we process personal information on one or more of the following legal bases:<br></br><br></br>

<b>Performance of a contract</b><br></br><br></br>

We process information necessary to create and manage your account and provide account-based features such as favourites and wishlists because this processing is necessary to provide the services you request.<br></br><br></br>

<b>Legitimate interests</b><br></br><br></br>

We may process limited information where this is necessary for legitimate interests such as maintaining the security, reliability, and functionality of London Mapped, provided those interests are not overridden by your rights and interests.<br></br><br></br>

<b>Legal obligations</b><br></br><br></br>

We may process or retain information where necessary to comply with a legal obligation.<br></br><br></br>

Where we rely on consent for a particular processing activity, we will ask for consent where required and explain how you can withdraw it.</p>

<h3>5. Supabase</h3>

<p>London Mapped uses Supabase for authentication and database services. Supabase processes information on our behalf in connection with providing these services. The information processed through Supabase may include account information and the user and restaurant identifiers associated with your favourites and wishlist. Supabase operates as a third-party service provider and may process information in accordance with its own terms, privacy documentation, and applicable data protection requirements. You can learn more about Supabase's privacy and data protection practices through its website.</p>

<h3>6. Sharing of information</h3>

<p>We do not sell, rent, or otherwise provide your personal information to third parties for their own advertising or marketing purposes.<br></br><br></br>

We may share or allow access to information with service providers where this is necessary to operate London Mapped. Currently, our primary third-party service for account authentication and associated database functionality is Supabase.<br></br><br></br>

We may also disclose information where reasonably necessary to:<br></br><br></br>

Comply with a legal obligation;<br></br>
Respond to a lawful request from a public authority;<br></br>
Protect the rights, safety, or property of London Mapped, its users, or others; or<br></br>
Detect, prevent, or address security, fraud, or technical issues.</p>

<h3>7. International data processing</h3>

<p>London Mapped uses Supabase as a third-party service provider. Depending on the configuration of our Supabase project and the services used, personal information may be processed or stored in locations outside the United Kingdom.<br></br><br></br>

Where applicable, we will use appropriate safeguards required by applicable data protection law for international transfers of personal information.</p>

<h3>8. How long we keep your information</h3>

<p>We keep personal information only for as long as reasonably necessary for the purposes described in this Privacy Policy.<br></br><br></br>

Your account information is retained while your London Mapped account remains active.<br></br><br></br>

Your favourites and wishlist information is retained while it is associated with your account and is needed to provide the relevant functionality.<br></br><br></br>

When you delete your account, we will delete or anonymise personal information associated with your account unless we are legally required or permitted to retain particular information.<br></br><br></br>

Some information may remain temporarily in backups or security logs and will be removed in accordance with our normal retention and deletion processes.</p>

<h3>9. Account deletion</h3>

<p>You can delete your London Mapped account from within the application.<br></br><br></br>

When you request account deletion, we will delete the account and associated information that we are not legally required to retain.<br></br><br></br>

This includes information associated with your favourites and wishlist.<br></br><br></br>

Account deletion is intended to be permanent. Once your account has been deleted, your saved favourites and wishlist cannot be recovered.<br></br><br></br>

If you are unable to access the account deletion function, you can contact us at:<br></br><br></br>

hadley.long.dev@gmail.com<br></br><br></br>

We may need to verify your identity before processing a deletion request.</p>

<h3>10. Your privacy rights</h3>

<p>Depending on your circumstances and applicable UK data protection law, you may have rights including:<br></br><br></br>

The right to access personal information we hold about you;<br></br>
The right to request correction of inaccurate information;<br></br>
The right to request deletion of your personal information;<br></br>
The right to request restriction of processing;<br></br>
The right to object to certain processing;<br></br>
The right to data portability in applicable circumstances; and<br></br>
The right to withdraw consent where we rely on consent as our legal basis.<br></br>

You can exercise applicable rights by contacting the London Mapped team:<br></br><br></br>

We will respond to requests in accordance with applicable data protection law.</p>

<h3>11. Security</h3>

<p>We take reasonable technical and organisational measures to protect personal information against unauthorised access, loss, misuse, alteration, or disclosure.<br></br><br></br>

However, no internet-based service can be guaranteed to be completely secure. You should use a strong, unique password for your account and avoid sharing your authentication credentials with others.</p>

<h3>12. Children's privacy</h3>

<p>London Mapped is a general-audience application and is not specifically directed at children.<br></br><br></br>

We do not knowingly collect personal information from children in circumstances where doing so would be unlawful.</p>

<h3>13. Changes to this Privacy Policy</h3>

<p>We may update this Privacy Policy from time to time to reflect changes to London Mapped, changes to the services we use, changes in applicable law, or changes to our data-processing practices.<br></br><br></br>

When we make changes, we will update the "Last updated" date at the top of this Privacy Policy.<br></br><br></br>

If we introduce new features that involve additional personal information, such as precise location, user-uploaded photographs, messaging, analytics, or advertising, we will update this Privacy Policy and provide any additional notices or permissions required by applicable law.</p>

<h3>14. Contact</h3>

<p>If you have questions about this Privacy Policy, your personal information, or London Mapped's privacy practices, please contact:<br></br><br></br>

London Mapped<br></br>
United Kingdom<br></br>
Email: hadley.long.dev@gmail.com<br></br>

London Mapped
United Kingdom</p>
    </div>
  );
}

export default PrivacyPolicy;